function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  cx: 63.84,
  cy: 63.525,
  r: 60.675
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M45.719,20.111c0,0,16.515,8.357,18.131,9.165  c1.617,0.808,22.562,9.272,24.582,9.878c2.021,0.606,19.225,6.126,19.225,6.126"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M20.429,82.176c0,0,8.559-17.018,9.367-18.634  c0.808-1.616,9.271-22.563,9.877-24.583c0.606-2.021,6.039-18.926,6.039-18.926"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M20.368,82.329c0,0,18.399,5.422,20.114,5.994  c1.714,0.57,22.02,9.03,23.877,10.03c1.856,1,18.038,9.207,18.038,9.207"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M107.687,45.25c0,0-8.44,16.999-9.249,18.615  c-0.809,1.616-9.271,22.563-9.877,24.583c-0.605,2.021-6.104,19.051-6.104,19.051"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M81.844,19.866c0,0,5.857,17.676,6.429,19.391  c0.571,1.714,9.397,22.511,10.397,24.368s9.238,17.985,9.238,17.985"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M20.122,45.803c0,0,18.128-5.828,19.843-6.399  c1.714-0.572,22.509-9.398,24.366-10.398c1.857-1,17.453-9.14,17.453-9.14"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M20.122,45.895c0,0,9.07,16.971,9.878,18.587  c0.808,1.616,9.185,21.958,9.791,23.978c0.606,2.021,6.328,19.223,6.328,19.223"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  d: "M107.861,81.708c0,0-17.873,5.896-19.587,6.467  c-1.714,0.57-22.509,9.398-24.366,10.398c-1.857,1-17.651,9.111-17.651,9.111"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "3.211,64.374 20.153,45.772   20.644,20.971 45.774,20.129 63.92,2.953 81.905,19.835 106.674,20.787 107.687,45.281 124.383,63.513 107.861,81.61   106.999,106.14 82.458,107.56 64.657,124.258 46.057,107.683 21.718,107.008 20.368,82.268 "
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 7.661,
  y1: 40.738,
  x2: 20.091,
  y2: 45.833
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 40.533,
  y1: 7.496,
  x2: 45.719,
  y2: 20.173
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 86.724,
  y1: 7.404,
  x2: 81.875,
  y2: 19.743
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 119.81,
  y1: 40.124,
  x2: 107.656,
  y2: 45.25
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 107.861,
  y1: 81.659,
  x2: 120.09,
  y2: 86.551
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 82.458,
  y1: 107.622,
  x2: 87.519,
  y2: 119.691
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 46.126,
  y1: 107.62,
  x2: 41.429,
  y2: 120.042
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 20.306,
  y1: 82.268,
  x2: 8.183,
  y2: 87.456
});

const SvgRound = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  x: "0px",
  y: "0px",
  width: "127.333px",
  height: "127.333px",
  viewBox: "0 0 127.333 127.333",
  enableBackground: "new 0 0 127.333 127.333",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/round.03b5a276.svg";
export { ForwardRef as ReactComponent };